
import { removeHtml } from '@/utils/helpers'

function pickDiagramProperties (diagram) {
  return {
    id: diagram.id,
    url: diagram.url,
    title: diagram.title,
    name: diagram.name,
    tags: diagram.tags,
    breadcrumbs: diagram.breadcrumbs,
    image: diagram.image,
    price: diagram.price,
    meta_description: diagram.meta_description,
    slides_count: diagram.slides_count
  }
}

function pickSlideProperties (slide) {
  return {
    number: slide.number,
    url_title: slide.url_title,
    title: slide.title,
    keywords_list: slide.keywords_list,
    keywords: slide.keywords,
    abstract: slide.abstract,
    image: slide.image
  }
}

export default {
  components: {
    'promo-banner': () => import('~/components/banners/promoBaner.vue'),
    'id-slide-description': () => import('~/components/slide/lazy/Description.vue'),
    'id-lazy-breadcrumbs': () => import('~/components/lazy/Breadcrumbs.vue'),
    'id-diagram-lazy-value-description': () => import('~/components/diagram/lazy/ValueDescription.vue')
    // 'id-slide-lazy-tabs': () => import('~/components/slide/lazy/Tabs.vue')
  },
  transition: 'page',
  async asyncData ({
    $serverBackend,
    params,
    payload,
    error,
    redirect
  }) {
    let diagram, slide, image
    if (payload && payload.slide) {
      return {
        diagram: pickDiagramProperties(payload.diagram),
        slide: pickSlideProperties(payload.slide),
        image: payload.slide.image
      }
    } else {
      const slideUrl = removeHtml(params.url_title)
      slide = (await $serverBackend.get('/slides/', { url_title: slideUrl })).results[0]
      if (!slide) {
        const slide = (await $serverBackend.get('/slides/', { previous_urls: slideUrl })).results[0]
        if (slide) {
          return redirect(301, `/slides/${slide.url_title}/`)
        } else {
          return error({
            statusCode: 404,
            message: 'Slide not found'
          })
        }
      }
      diagram = await $serverBackend.get(`/diagrams/${slide.diagrams[0]}/`)
      image = slide.image
      return {
        diagram: pickDiagramProperties(diagram),
        slide: pickSlideProperties(slide),
        image
      }
    }
  },
  head () {
    return {
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.pageTitle
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'InfoDiagram.com'
        },
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescription
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.slide.keywords
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.image.full_size.png
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDescription
        }
      ],
      title: this.pageTitle,
      bodyAttrs: {
        class: 'page-diagram page-slide'
      }
    }
  },
  computed: {
    metaDescription () {
      return this.slide.meta_description || this.diagram.meta_description
    },
    diagramPageUrl () {
      return `/diagrams/${this.diagram.url}/#slide_${this.slide.number}`
    },
    pageTitle () {
      try {
        return this.slide.title
      } catch {
        return 'InfoDiagram PowerPoint Slides'
      }
    }
  }
}
